import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-Proposition13',
    templateUrl: './Proposition13.component.html',
    styleUrls: ['./Proposition13.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Proposition13Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
